import { getBrowserName, getIsTouch } from './../utils/other'

export default {
  install (Vue: any) {
    Vue.directive('event-dependent-focus', {
      inserted: function (el: any, { value }: { value: string }) {
        const textFields = el.querySelectorAll('input')
        const textField = textFields.length > 0 ? textFields[textFields.length - 1] : textFields[0]
        if (!textField) return
        if (getBrowserName() === 'safari' && getIsTouch()) return
        if (value === undefined) {
          textField.focus()
          return
        }
        const setFocus = () => { textField.focus(); el.removeEventListener(value, setFocus, false) }
        el.addEventListener(value, setFocus, false)
      }
    })
  }
}
